import React, { Component, Fragment } from "react";

class Step5Download extends Component {
    componentDidMount() {
        setTimeout(() => {
            window.scroll({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
        }, 100);
    }

    render() {
        const { pdfUrl } = this.props;
        const today = new Date(),
            time =
                today.getHours() +
                ":" +
                today.getMinutes() +
                ":" +
                today.getSeconds();
        const day =
            today.getMonth() +
            1 +
            "-" +
            today.getDate() +
            "-" +
            today.getFullYear();

        return (
            <Fragment>
                <div className="row">
                    <h2 className="blue-font-35-gelo">
                        Your enrollment form has been submitted successfully on{" "}
                        {day} at {time}.
                    </h2>
                    <div className="spacer-small">&nbsp;</div>
                    {/*<p>
                      Contact us at 1-844-737-2223 Monday through Friday, 8:00 am to 8:00 pm ET. <br></br>
                    </p>*/}
                </div>
                <div className="row spacer-medium">&nbsp;</div>
                <div className="row">
                    <div className="col-md-12 pl-0">
                        <a href={pdfUrl} target="_blank">
                            <button
                                id="treatment-form-download-pdf"
                                className={"button blue"}
                                type="button"
                                target="_blank"
                            >
                                Download (
                                <i
                                    className="fa fa-file-pdf-o"
                                    aria-hidden="true"
                                ></i>{" "}
                                PDF)
                            </button>
                        </a>
                    </div>
                </div>
                <div className="row spacer-small">&nbsp;</div>
                <div className="row spacer-medium mobile">&nbsp;</div>
                <div className="row">
                    <div className="col-md-12 pl-0">
                        <a
                            className="underline-link"
                            href="/nuplazid/healthcare-providers"
                        >
                            Return to homepage
                        </a>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default Step5Download;
